import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SettingsDrawerState {
  isSettingsOpen: boolean;
}

const initialState: SettingsDrawerState = {
  isSettingsOpen: false,

};

export const settingsDrawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    setSettingsOpen: (state, action: PayloadAction<boolean>) => {
      state.isSettingsOpen = action.payload;
    },
  },
});

export const { setSettingsOpen } = settingsDrawerSlice.actions;
export default settingsDrawerSlice.reducer;